import React from 'react';
import ResponsiveLayout from '../../components/common/ResponsiveLayout';
import OtpFlow from '../../components/preview/OtpFlow';

const OtpRequestPage: React.FC = () => {
  return (
    <ResponsiveLayout>
      <OtpFlow />
    </ResponsiveLayout>
  );
};

export default OtpRequestPage;
